<ng-container *t="let t">
    <!-- ValidationTask check-->
    <tsl-alert status="info" *ngIf="!validationTask; else showmsg" i18n="@@taxGridMsg1" t="taxGridMsg1">
        You do not have access to view this data or the ability for change functionality due to the Contact Validation Task
        not being completed by your organization’s Primary Contact. If you do not have a Primary Contact, please designate a
        contact for your organization, and have them reach out to Vendorchanges@tesla.com for task assignment to receive
        applicable user access.
    </tsl-alert>
    <ng-template #showmsg>
        <ng-container [ngSwitch]="validationTask.statusId">
            <tsl-alert status="info" *ngSwitchCase="1">
                <p i18n="@@6867665126144963083" t="6867665126144963083"
                    >As your contacts have not yet been validated you do not have complete user access and, if applicable,
                    change functionality within the Supplier Portal. Please reach out to the Tesla Vendor Changes Team for
                    further assistance
                </p>
                <div>
                    <span i18n="@@9097415673098704514" t="9097415673098704514" style="font-weight: bold;">
                        Tesla Supplier onboarding and data inquiries
                    </span>
                    <br />
                    <span i18n="@@contactVendorChanges" t="contactVendorChanges">
                        Contact the Vendor Changes Team at the following resources:
                    </span>
                    <br />
                    <ul>
                        <li>
                            <span i18n="@@globalTeamRegions" t="globalTeamRegions">
                                EMEA/NA/SA:
                            </span>
                            <a class="link" i18n="@@HomeTabHelpNewEmail" t="HomeTabHelpNewEmail" href="mailto:Vendorchanges@tesla.com">
                                Tesla Vendor Changes Team
                            </a>
                        </li>
                        <li>
                            <span i18n="@@apacTeamRegions" t="apacTeamRegions">
                                APAC/CN:
                            </span>
                            <a class="link" i18n="@@VendorchangesapacEmail" t="VendorchangesapacEmail" href="mailto:Vendorchangesapac@tesla.com">
                                Tesla Vendor Changes APAC Team
                            </a>
                        </li>
                    </ul>
                </div>
            </tsl-alert>
            <ng-container *ngSwitchCase="3">
                <tsl-alert class="alert" status="info" *ngIf="!isPCFUploaded" class="pcfNotUploaded && !showMFADialog">
                    <span i18n="@@notAuthenticated"
                            t="notAuthenticated" style="font-weight: bold;">
                            Your account is not fully authenticated.
                        </span>
                        <br>
                        <span i18n="@@noeditFunctionality"
                            t="noeditFunctionality">
                            No edit functionality available at this time.
                        </span>
                        <br>
                        <span i18n="@@enrollToMFA"
                            t="enrollToMFA">
                            (Re)authentication or (Re)enrollment in Multi-Factor Authentication required.
                        </span>
                    <br />
                    <a
                        style="text-decoration: underline; font-weight: bold; cursor: pointer;"
                        [ngClass]="{ 'disable_link': primaryPendingForApproval == true }"
                        (click)="openPCFDialog()"
                        >Take Action</a
                    >.
                </tsl-alert>
            </ng-container>
            <ng-container *ngSwitchCase="2">
                <tsl-alert status="info">
                    <p>
                        <span i18n="@@4552874665027862249" t="4552874665027862249">
                            As the Contact Validation Task by your organization's Primary Contact</span
                        >
                        <span class="bold-info"> {{ validationTask.email }} </span>
                        <span i18n="@@6667155305668146063" t="6667155305668146063"
                            >is currently pending, you currently do not have access to view this data or change
                            functionality. In order to view this data, please notify the above contact and request they log
                            into the Tesla Supplier Portal and complete the task by </span
                        ><span class="bold-info"> {{ validationTask.dueDateValue }} </span>.
                    </p>
                    <p *ngIf="isPrimary">
                        <span i18n="@@3295845337056041526" t="3295845337056041526"
                            >To access this task, please click</span
                        >
                        <a class="bold-info" href="#" (click)="navigateToValidationTask()">HERE</a>.
                    </p>
                    <p>
                        <span
                            ><b
                                i18n="@@e16702600f3bb303dcf8e62cf280925c67db2f88"
                                t="e16702600f3bb303dcf8e62cf280925c67db2f88"
                                >Please Note</b
                            ></span
                        >
                        <span i18n="@@5366570134397127155" t="5366570134397127155">
                            : Your portal account will be deactivated along other contacts within your organization,
                            consisting of all their portal access rights if NOT validated by the due date. This includes
                            access to Shipping 2.0, Quality, FTA Compliance, Carrier, E-Invoicing, Invoice Reports, and
                            Supplier Profile.</span
                        >
                    </p>
                </tsl-alert>
            </ng-container>
            <ng-container *ngSwitchCase="5">
                <tsl-alert status="info" i18n="@@5707243002146290694" t="5707243002146290694">
                    The Contact Validation Task is currently pending review with Tesla which may take up to 24 to 48 hours
                    from the time of submission of the most recently completed task. Change functionality will be instated
                    and applicable user access granted once all tasks have been completed and approved.
                </tsl-alert>
            </ng-container>
            <tsl-alert
                status="info"
                *ngSwitchDefault
                i18n="@@4804233320533880161"
                t="4804233320533880161"
                [tParams]="[validationTask.email]"
            >
                As the Contact Validation Task by your organization’s Primary Contact
                {{ validationTask.email }} is still pending, you currently do not have access to view this data or change
                functionality. In order to view this data, please notify the above contact and request they log into the
                Tesla Supplier Portal and complete the task, which can be located on the Validation Task tab on Contacts
                page.</tsl-alert
            >
        </ng-container>
    </ng-template>

    <!-- add tax -->
    <div class="right">
        <button
            tsl-button
            size="small"
            color="black"
            outline
            tooltip="Show History" i18n-tooltip="@@2279638681844186468" #historyButton tslTooltip="{{ t('2279638681844186468', historyButton) }}"
            *ngIf="this.userDetails && tabPermissions?.tax != 'NoAccess'"
            (click)="showHistory()"
            i18n="@@efac3af0b32e953279c25b6519cae256811e0fe8"
            t="efac3af0b32e953279c25b6519cae256811e0fe8"
            >History</button
        >
        <button
            *ngIf="hasWriteAccess"
            tsl-button
            [disabled]="preventativeHold==true"
            size="small"
            color="blue"
            (click)="openTaxDialog(null)"
            i18n="@@AddTax"
            t="AddTax"
            >Add Tax</button
        >
    </div>

    <!-- grid start -->
    <table tsl-table [dataSource]="datasource" displayStripes="false">
        <!-- Tax Name Column -->
        <ng-container tslColumnDef="taxName">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@TaxName" t="TaxName">Tax Name</th>
            <td tsl-cell *tslCellDef="let row">
                <div *ngIf="row.taxName?.newValue; else empty">
                    {{ row.taxName?.newValue }}
                </div>
            </td>
        </ng-container>

        <!-- Tax Type Column -->
        <ng-container tslColumnDef="taxTypeName">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@TaxType" t="TaxType">Tax Type</th>
            <td tsl-cell *tslCellDef="let row">
                <div *ngIf="row.taxIDTypes?.newValue; else empty">
                    {{ getTaxType(row.taxIDTypes?.newValue) }}
                </div>
            </td>
        </ng-container>

        <!-- Tax Country Column -->
        <ng-container tslColumnDef="taxCountry">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@TaxCountry" t="TaxCountry">Tax Country</th>
            <td tsl-cell *tslCellDef="let row">
                <span *ngIf="row.taxCountry?.newValue; else empty">
                    {{ getTaxCountry(row.taxCountry?.newValue) }}
                </span>
            </td>
        </ng-container>

        <ng-container tslColumnDef="taxID">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@TaxID" t="TaxID">TaxID</th>
            <td tsl-cell *tslCellDef="let row">
                <span *ngIf="row.federalTaxID?.newValue; else empty">
                    {{ row.federalTaxID?.newValue }}
                </span>
            </td>
        </ng-container>

        <ng-container tslColumnDef="tax1099BoxName">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@1099Box" t="1099Box">1099Box</th>
            <td tsl-cell *tslCellDef="let row">
                <span *ngIf="row.tax1099Box?.newValue; else empty">
                    {{ row.tax1099Box?.newValue }}
                </span>
            </td>
        </ng-container>

        <ng-container tslColumnDef="vatNumber">
            <th tsl-header-cell *tslHeaderCellDef i18n="@@VATNumber" t="VATNumber">VAT Number</th>
            <td tsl-cell *tslCellDef="let row">
                <span *ngIf="row.vatNumber?.newValue; else empty">
                    {{ row.vatNumber?.newValue }}
                </span>
            </td>
        </ng-container>

        <!-- End Column -->

        <!-- Action Column -->
        <ng-container tslColumnDef="actions">
            <th tsl-header-cell *tslHeaderCellDef class="actions icons" i18n="@@Actions" t="Actions">Actions</th>
            <td tsl-cell *tslCellDef="let row">
                <div *ngIf="hasEditPermissions">
                    <h4 *ngIf="row.operation.newValue">
                        <div class="task-status">
                            <tsl-chip [ngClass]="statusClass['Under Tesla Review']">
                                {{ translateService.get(statusDisplay['Under Tesla Review']) }}
                            </tsl-chip>
                        </div>
                    </h4>
                    <ng-container *ngIf="!row.operation.newValue">
                        <button
                            tsl-icon-button
                            (click)="openTaxDialog(row)"
                            [disabled]="!(canChangeItem(row) && row.operation?.newValue !== 'Delete')||preventativeHold==true"
                        >
                            <tsl-icon
                                status="primary"
                                tslTooltip="{{ translateService.get(isContactValidationPendingTaskErrorMessage) }}"
                                [tslTooltipDisabled]="canChangeItem(row) && row.operation?.newValue !== 'Delete'"
                                >edit</tsl-icon
                            >
                        </button>
                        <button
                            tsl-icon-button
                            (click)="deleteItem(row)"
                            [disabled]="!(canChangeItem(row) && row.operation?.newValue !== 'Delete')||preventativeHold==true"
                        >
                            <tsl-icon
                                status="error"
                                tslTooltip="{{ translateService.get(isContactValidationPendingTaskErrorMessage) }}"
                                [tslTooltipDisabled]="canChangeItem(row) && row.operation?.newValue !== 'Delete'"
                                >delete</tsl-icon
                            >
                        </button>
                    </ng-container>
                </div>
            </td>
        </ng-container>

        <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
        <tr tsl-row *tslRowDef="let row; columns: displayedColumns"></tr>

        <ng-template #empty>
            <tsl-icon>maximize</tsl-icon>
        </ng-template>
    </table>

    <!-- grid pagination -->
    <tsl-pagination
        showFirstLastButtons
        [pageSizeOptions]="pageSizeOptions"
        [total]="total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (pageChange)="onPageChange($event)"
        [itemsPerPageLabel]="translateService.get('ItemsPerPage')"
    >
    </tsl-pagination>
</ng-container>